import { defineNotificationCategory, requireFields } from './types';

export const portfolioCreatedDescriptor = defineNotificationCategory('portfolio_created', {
  isAvailable: () => true,
  actionUrl: (data, organizationId) => `/org-id/${organizationId}/loop/${data.loopId}`,
});

export const teamAssignmentChangedDescriptor = defineNotificationCategory(
  'team_assignment_changed',
  {
    isAvailable: () => true,
    actionUrl: (data, organizationId) => `/org-id/${organizationId}/loop/${data.loopId}`,
  },
);

export const planPublishedDescriptor = defineNotificationCategory('plan_published', {
  isAvailable: requireFields('portfolioName'),
  actionUrl: (data, organizationId) => `/org-id/${organizationId}/loop/${data.loopId}`,
  serverCopy: {
    titleKey: 'planPublished.title',
    bodyKey: 'planPublished.serverBody',
    values: (data) => ({ portfolioName: data.portfolioName }),
  },
});

export const objectiveHealthChangedDescriptor = defineNotificationCategory(
  'objective_health_changed',
  {
    isAvailable: requireFields('objectiveName'),
    actionUrl: (data, organizationId) =>
      data.loopId != null
        ? `/org-id/${organizationId}/loop/${data.loopId}/overview`
        : `/org-id/${organizationId}/objectives`,
    serverCopy: {
      titleKey: 'objectiveHealthChanged.title',
      bodyKey: 'objectiveHealthChanged.serverBody',
      values: (data) => ({ objectiveName: data.objectiveName, status: data.newStatus }),
    },
  },
);

export const objectiveDriftDetectedDescriptor = defineNotificationCategory(
  'objective_drift_detected',
  {
    isAvailable: requireFields('objectiveName'),
    actionUrl: (data, organizationId) =>
      data.loopId != null
        ? `/org-id/${organizationId}/loop/${data.loopId}/overview`
        : `/org-id/${organizationId}/objectives`,
    serverCopy: {
      titleKey: 'objectiveDriftDetected.emailSubject',
      bodyKey: 'objectiveDriftDetected.serverBody',
      values: (data, tn) => ({
        objectiveName: data.objectiveName,
        status: tn(`objectiveDriftDetected.status.${data.newStatus}`),
        previous: tn(`objectiveDriftDetected.status.${data.previousStatus}`),
      }),
    },
  },
);

export const exportCompletionDescriptor = defineNotificationCategory('export_completion', {
  isAvailable: () => true,
  actionUrl: (data, organizationId) =>
    `/org-id/${organizationId}/loop/${data.loopId}/visualizations/view/${data.viewId}/${data.visualizationType}`,
  pills: (_data, ctx) => (ctx.loopName ? [ctx.loopName, 'Export'] : ['Export']),
});
